/*
 * @Author: cc
 * @Date: 2020-05-15 11:32:45
 * @LastEditTime: 2020-05-22 19:49:29
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\repetitive\repetitiveBtnService.js
 * @Description: 采编中心重复的按钮服务
 */
angular.module('editingCenterServiceModule').factory('editRepetitiveBtnService', ['$q', '$state', '$filter', 'trsHttpService', 'trsspliceString', 'websiteService', 'editingCenterService', 'modalDialog', function ($q, $state, $filter, trsHttpService, trsspliceString, websiteService, editingCenterService, modalDialog) {
    return {
        multipleChannelSign: multipleChannelSign, // 多签方法
        multiSignedMark: multiSignedMark, // 多签标记
        dealListImg: dealListImg, // 处理图示方法(采编很多图示，暂定先放在这个服务里面)
    };

    /**
     * [request description] 数据请求
     * @param   {[object]}  params       [params description] 请求参数 
     * @param   {[string]}  requestType  [requestType description] 请求方式
     * @return  {[promise]}              [return description] promise对象
     */
    function request(params, requestType) {
        var defer = $q.defer();
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, requestType).then((data) => {
            defer.resolve(data);
        }, (error) => {
            defer.reject(error);
        });
        return defer.promise;
    }

    /**
     * [dealMultiSignIds description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    function dealMultiSignIds(item) {
        return item.MODAL === '2';
    }

    /**
     * multiSignedMark: 多签标记
     * @param   {[Array]}  list  [list description] 数据集合
     * @return  {[promise]}      [return description]
     */
    function multiSignedMark(list) {
        var defer = $q.defer();
        var multiSignedIds = $filter('pick')(list, dealMultiSignIds);
        if (multiSignedIds.length) {
            var params = {
                serviceid: 'mlf_metaviewdata',
                methodname: 'queryDuoQianInfo',
                ChnlDocIds: trsspliceString.spliceString(multiSignedIds, 'CHNLDOCID', ',')
            };
            request(params, 'post').then((data) => {
                var secondParams = {
                    datas: list,
                    requestDatas: data,
                    newAttr: 'ORIGINCHANNEL'
                };
                editingCenterService.dealSecondRequest(secondParams);
                defer.resolve(data);
            });
        }
        return defer.promise;
    }

    /**
     * [multipleChannelSign description] 多签方法
     * @param   {[Array]}  items  [items description] 稿件集合
     * @return  {[promise]}       [return description]
     */
    function multipleChannelSign(items, platform) {
        var defer = $q.defer();
        websiteService.batChooseChnl(
            '多签',
            $state.params.siteid,
            platform,
            function (data) {
                var params = {
                    serviceid: $state.current.name.split('.')[2] === 'app' ? 'mlf_appoper' : 'mlf_websiteoper', // 考虑到使用的简单跟目前实际项目情况（存在的只有app跟网站）,这里用判断就不传入参数了
                    methodname: 'transmitDoc',
                    ChnlDocIds: trsspliceString.spliceString(items, 'CHNLDOCID', ','),
                    ChannelIds: data.ChannelIds,
                    CurrChnlId: $state.params.channelid,
                    isLink: data.selectedRadio,
                };
                request(params, 'post').then((data) => {
                    modalDialog.alertType('多签成功', '', 'success', false);
                    defer.resolve(data);
                }, (error) => {
                    defer.reject(error);
                });
            });
        return defer.promise;
    }

    /**
     * [datas description] 处理列表上的图示
     *
     * @param   {[type]}  datas  [datas description]
     *
     * @return  {[type]}         [return description]
     */
    function dealListImg(datas) {
        var defer = $q.defer();
        if (!datas || datas.length < 1) {
            defer.resolve([]);
        } else {
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: 'queryAllImgLogo',
                metadataids: trsspliceString.spliceString(datas, 'METADATAID', ','),
            };
            request(params, 'post').then((data) => {
                var secondParams = {
                    datas: datas,
                    requestDatas: data,
                    newAttr: 'ALLIMG', // 需要新增的属性名称
                };
                editingCenterService.dealSecondRequest(secondParams);
                defer.resolve(data);
            });
        }
        return defer.promise;
    }
}]);
